import * as idb from 'idb';
import { freeze } from "@/helpers/freeze";

const db = {
    async init() {
        const tables = [
            'test_table',
            'images',
            'files',
            'work_intervals',
        ]
        this.db = await idb.openDB('db', 1, {
            upgrade(db) {
                for (const table of tables) {
                    if (db.objectStoreNames.contains(table)) {
                        continue;
                    }
                    db.createObjectStore(table, {keyPath: 'id'});
                }
            }
        });
    },

    restore(table) {
        const tx = this.db.transaction(table);
        const store = tx.objectStore(table);
        return store.getAll();
    },

    async save(table, data) {
        data = data.map(x => freeze(x));
        for (const one of data) {
            const tx = this.db.transaction(table, 'readwrite');
            await tx.objectStore(table).put(one);
        }
    },

    findOne(table, id) {
        return this.db.get(table, id);
    },

    async saveOne(table, id, data) {
        if (id < 0) {
            try {
                await this.db.delete(table, id);
            } catch (e) {
            }
        }
        return this.db.put(table, freeze(data));
    },

    remove(table) {
        return this.db.clear(table);
    },
};

const handler = {
    get(target, property, receiver) {
        const originalMethod = target[property];
        if (typeof originalMethod !== "function") {
            return originalMethod;
        }
        return async function (...args) {
            await target.init();
            return originalMethod.apply(this, args);
        };
    },
};
const dbProxy = new Proxy(db, handler);
export default dbProxy;